import {styled, Chip} from 'external/material'
import {useMemo} from 'external/react'
import Link from 'components/LinkBehavior'
import Group from 'components/Group'
import useSession from 'hooks/session'
import { centerVertically } from 'utils/style'

const StyledDashboardCourse = styled(Link)(dashboardCourseStyles)

export default function DashboardCourse(props) {
    const {navigation} = useSession()
    const {id, assignment} = props
    const courseName = useMemo(() => {
        return props.courseName
            ? props.courseName.replace(/ - Dreyfous.*$/, '')
            : ''
    }, [props.courseName])
    const assignmentCount = useMemo(() => {
        return assignment
            ? Object.values(assignment).reduce((a , b) => a + b)
            : false
    }, [assignment])
    const courseLink = navigation.section.link({pageName: 'my-courses',groupId: id, section: 'units'})
    return <StyledDashboardCourse to={courseLink} className="dashboardCourse">
        <div className="names">
            <Group fill={'#798092'} className="course" name={courseName} width={21} />
        </div>
        {assignmentCount &&(
            <div className="assignments">
                <Chip label={assignmentCount} />
            </div>
        )}
            
    </StyledDashboardCourse>
}

function dashboardCourseStyles({theme}) {
    return {
        [theme.breakpoints.down('desktop')]: {
            height: 60,
            marginTop: 10,
            maxHeight: 60,
            minHeight: 60,
            "& .groupName": {
                marginLeft: 8,
                fontSize: '9.0pt',
                color: '#434b5f',
                fontWeight: 'bold'
            }

        },
        [theme.breakpoints.up('desktop')]: {
            marginTop: 12,
            height: 70,
            maxHeight: 70,
            minHeight: 70,
            "& .groupName": {
                marginLeft: 8,
                fontSize: '10.0pt',
                color: '#434b5f',
                fontWeight: 'bold'
            }
        },
        '&:last-of-type': {
            marginBottom: 20
        },
        textDecoration: 'none',
        display: 'flex',
        padding: '0 10px',
        borderRadius: 10,
        color: '#798092',
        border: 'solid 1px #e5e7ee',
        boxShadow: '1px 0px 2px #e5e7ee',
        "&:hover": {
            boxShadow: '-2px 0px 8px #e5e7ee',
            transform: 'scale(1.005)'
        },
        "& .names": {
            ...centerVertically,
            flexGrow: 1
        },
        "& .assignments": {
            display: 'flex',
            marginLeft: 10,
            flexDirection: 'column',
            justifyContent: 'center',
            "& .MuiChip-root": {
                backgroundColor: '#f14933',
                textAlign: 'center',
                color: '#fff',
                fontSize: '9pt',
                height: 20,
                width: 45
            }
        },
        "& .course": {
        },
        "& .group": {
            display: 'flex'
        },
        "& .groupIcon": {
            ...centerVertically,
            marginTop: -1
        },
    }
}